import { MutationTree } from 'vuex';
import { StatisticState } from './types';

export const mutations: MutationTree<StatisticState> = {

    setCallStatisticGroup: (state, data) => {
        state.callStatisticGroup = data;
    },
    setCallStatisticDetail: (state, data) => {
        state.callStatisticDetail = data
    },
    pushCallStatisticDetail: (state, data) => {
        state.callStatisticDetail = state.callStatisticDetail.concat(data)
    },
};